import $ from "jquery";
import React from 'react';
import PropTypes from 'prop-types';
import { render } from 'react-dom';
import { createStore, combineReducers } from 'redux';
import { Provider } from 'react-redux';
import { IntlProvider } from 'react-intl';
import { Header, reducer } from 'viihdeonline-shared-components';
import { BrowserRouter as Router } from 'react-router-dom';
import { user as userProperty, login, logout } from 'login';

import '@formatjs/intl-pluralrules/polyfill';
import '@formatjs/intl-pluralrules/locale-data/fi';
import '@formatjs/intl-pluralrules/locale-data/sv';
import '@formatjs/intl-pluralrules/locale-data/en';
import '@formatjs/intl-relativetimeformat/polyfill';
import '@formatjs/intl-relativetimeformat/locale-data/fi';
import '@formatjs/intl-relativetimeformat/locale-data/sv';
import '@formatjs/intl-relativetimeformat/locale-data/en';

/*jshint browser: true */

function onLanguageSelect(locale) {
  document.cookie = `locale=${locale};path=/`;
  location.reload();
}

function decodeTitleNameToFriendlyUri(titleName) {
  return titleName.replace(/[^a-zA-Z0-9 ]/g, '').replace(/ /g, '-').toLowerCase();
}

function onSearchResultClick(loggedIn, searchResult, onClickDefault) {
  if (searchResult.sourceType && ['evv', 'viaplay', 'ruutuplus'].includes(searchResult.sourceType)) {
    const target = searchResult.sourceType === 'evv' ? 'viaplay' : searchResult.sourceType;
    const itemType = $(this).data('type') === 'series' ? 'sarjat' : 'elokuvat';
    window.location.href = `/${target}/${itemType}/${searchResult.id}/${decodeTitleNameToFriendlyUri(searchResult.name)}`;
  } else {
    onClickDefault();
  }
}

function renderNavigation(store, user, configuration, translations) {
  render(
    <Navigation store={store} user={user} configuration={configuration} translations={translations} />,
    document.getElementById('viihde-top-navigation-placeholder')
  );
}

function Navigation(props) {
  const { store, user, configuration, translations } = props;

  if (document.getElementById('oneTrustCookiesConsentScript') && user.locale) {
    (async () => {
      while (!Object.prototype.hasOwnProperty.call(window, 'OneTrust')) {
        await new Promise(resolve => setTimeout(resolve, 250));
      }
      window.OneTrust.changeLanguage(user.locale);
    })();
  }

  return (
    <Provider store={store}>
      <IntlProvider defaultLocale="fi" locale={user.locale || 'fi'} messages={translations} textComponent="span">
        <Router>
          <Header
            useRouter={false}
            loggedIn={Boolean(user && user.username)}
            user={user}
            onLogin={response => login(response.data)}
            onLogout={logout}
            configuration={{
              userAccountApi: configuration.userAccountApi,
              viewApi: configuration.viewApi,
              userApi: configuration.userSessionApi,
              searchApi: configuration.searchApi,
              ssoApi: configuration.ssoApi,
              epgApi: configuration.epgApi,
              recordingsApi: configuration.recordingsApi,
              margeApi: configuration.margeApi,
              elisaIdHost: configuration.elisaIdHost,
              elisaIdClientId: configuration.elisaIdClientId,
            }}
            onLanguageSelect={onLanguageSelect}
            onSearchResultClick={function (searchResult, onClickDefault) {
              onSearchResultClick(Boolean(user && user.username), searchResult, onClickDefault);
            }}
          />
        </Router>
      </IntlProvider>
    </Provider>
  );
}

Navigation.propTypes = {
  store: PropTypes.object,
  user: PropTypes.object,
  configuration: PropTypes.object,
  translations: PropTypes.object
};
Navigation.defaultProps = {
  configuration: {},
  translations: {}
};

let store;
export default {
  init: function () {
    const { navigationConfiguration, translations } = window;
    store = createStore(combineReducers({ ReactHeaderReducer: reducer }));
    userProperty.onValue(user => {
      renderNavigation(store, user, navigationConfiguration, translations);
    });
  },
  disableFixedLocalNavi: function () {
    $('html').addClass('hide-local-navi-on-scroll');
  },
  toggleLogin: function () {
    store.dispatch({ type: 'HEADER_TOGGLE_PROFILE' });
  }
};



// WEBPACK FOOTER //
// ./web/js/navi.js